<template lang="pug">
  .container
    .columns
      #overview-column.column.col-6.col-md-12
        h2 Checklist

        .card(v-if='checklist.intake.housing === "homeless"')
          .card-header
            .card-title.h5 Housing
            .card-subtitle.text-gray <strong>Estimated timeline:</strong> &lt; 1 year
          .card-body
            ol
              li Find temporary shelter
              li Get a TB card (See Transition Projects)
              li Get into a transitional housing program
              li If you have poor rental history, sign up for RentWell

        .card(v-if='checklist.intake.referral !== "referral"')
          .card-header
            .card-title.h5 Referral
            .card-subtitle.text-gray <strong>Estimated timeline:</strong> &lt; 1 month
          .card-body
            p Nonprofiters will help you get started, but a real case manager will help you finish. A case manager will help you write checks and provide referrals for things you may need.

        .card(v-if='checklist.intake.sex === "other"')
          .card-header
            .card-title.h5 GLBTQI Advocate
            .card-subtitle.text-gray Estimated timeline: &lt; 1 week
          .card-body
            p A GLBTQI advocate can help you gain access

      .column.col-6.col-md-12
        h2(style='margin-bottom: 5px') Resources
        resource-listing
</template>





<script>
  import ResourceListing from '@/components/resource/Listing'
  import {mapState} from 'vuex'

  export default {
    name: 'checklist-overview',

    components: {
      ResourceListing
    },

    computed: mapState([
      'checklist'
    ])
  }
</script>





<style lang="sass">
  .card-body
    ol:first-child, ul:first-child
      margin-top: 0

  #overview-column
    .card
      margin-bottom: 20px
</style>



// WEBPACK FOOTER //
// src/components/checklist/Overview.vue